export const READYTOJOIN = "Ready to Join"
export const TAKESURVEY = "Take Survey"
export const JOIN = "Join"
export const WAITLIST = "Waitlist"
export const ENROLL = "Enroll"
